import { useState } from 'react';
export default function Income({
	applicationType,
	incomeVerifications,
	setIncomeVerifications,
	defaultValues,
	description
}) {
	const [isUploading, setIsUploading] = useState(false);
	function addIncome() {
		setIncomeVerifications((prev) => [...prev, defaultValues]);
	}

	function removeIncome(index) {
		setIncomeVerifications((prev) => prev.filter((iv, i) => i !== index));
	}

	function updateIncomeVerification(index, attr) {
		setIncomeVerifications((prev) =>
			prev.map((iv, i) => {
				return i === index
					? {
							...iv,
							...attr
						}
					: iv;
			})
		);
	}

	async function uploadFile(event, i) {
		const files = event.target.files;
		if (files.length === 0) {
			updateIncomeVerification(i, {
				documentURL: ''
			});
		} else if (files.length > 0) {
			setIsUploading(true);

			if (files[0].size > 10485760) {
				alert('File Size Greater then 10MB!');
				event.target.value = '';
				setIsUploading(false);
				return;
			}

			const url = `https://api.cloudinary.com/v1_1/${process.env.NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME}/image/upload`;

			const { signature, timestamp } = await getSignature();

			const formData = new FormData();
			formData.append('signature', signature);
			formData.append('timestamp', timestamp);
			formData.append('file', files[0]);
			formData.append('upload_preset', 'elffund');
			formData.append('api_key', process.env.NEXT_PUBLIC_CLOUDINARY_KEY);

			const response = await fetch(url, {
				method: 'post',
				body: formData
			});
			const data = await response.json();

			if (data.error) {
				setIsUploading(false);
				console.error('Problem with File Upload', data.error.message);
				alert(`Problem Uploading: ${data.error.message}`);
				event.target.value = '';
				return;
			}
			setIsUploading(false);

			updateIncomeVerification(i, {
				documentURL: data.public_id,
				documentType: data.type
			});
		}
	}

	return (
		<div className="shadow-lg overflow-hidden mt-8 sm:rounded-md border" data-sentry-component="Income" data-sentry-source-file="index.jsx">
			<div className="px-4 py-5 ">
				<h2 className="border-b-2 mb-4 col-span-6  md:text-xl font-semibold">
					Income Verfication
				</h2>
				<p>{description && description}</p>
				{incomeVerifications.map((row, i) => {
					const required =
						applicationType !== 'senior' && i === 0 ? true : false;
					return (
						<div
							key={i}
							className=" grid grid-cols-6 gap-6  border-b pb-2  mt-8 md:mt-4 relative"
						>
							<div className="col-span-6 sm:col-span-6 lg:col-span-2">
								<label
									htmlFor="incomeAmmount"
									className="block text-sm font-medium text-gray-700"
								>
									Income Amount
								</label>
								<input
									onChange={(e) =>
										updateIncomeVerification(i, {
											income: e.target.value
										})
									}
									value={row.income}
									type="number"
									name="incomeAmmount"
									className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
								/>
							</div>

							<div className="col-span-6 sm:col-span-3 lg:col-span-2">
								<label
									htmlFor="source"
									className="block text-sm font-medium text-gray-700"
								>
									Source
								</label>
								<input
									onChange={(e) =>
										updateIncomeVerification(i, {
											source: e.target.value
										})
									}
									type="text"
									name="source"
									value={row.source}
									className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
								/>
							</div>
							<div className="col-span-6 sm:col-span-3 lg:col-span-2 ">
								<label
									htmlFor="document"
									className="block text-sm font-medium text-gray-700"
								>
									Verification Document (image or pdf){' '}
									{required && (
										<span className="text-red-600">*</span>
									)}
								</label>
								<input
									onChange={(e) => uploadFile(e, i)}
									type="file"
									name="documentURL"
									accept="image/gif, image/jpeg, image/png, application/pdf, image/webp"
									required={required}
									className=" mt-2 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-xs sm:text-sm file:mr-3 file:cursor-pointer file:rounded-md file:border file:border-gray-300 file:bg-gray-100 file:px-3 file:py-1.5 file:text-sm file:font-medium file:text-gray-700 hover:file:bg-gray-200"
								/>

								{isUploading && (
									<div className="text-xs pt-2 font-bold flex animate-pulse">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											className="h-4 w-4 mr-2"
											viewBox="0 0 20 20"
											fill="currentColor"
										>
											<path
												fillRule="evenodd"
												d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z"
												clipRule="evenodd"
											/>
										</svg>
										Uploading
									</div>
								)}
								{row.documentURL && (
									<div className="text-xs pt-2 font-bold flex">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											className="h-4 w-4 text-emerald-500 mr-2"
											viewBox="0 0 20 20"
											fill="currentColor"
										>
											<path
												fillRule="evenodd"
												d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
												clipRule="evenodd"
											/>
										</svg>
										Upload Successful
									</div>
								)}
							</div>

							{incomeVerifications.length > 1 ? (
								<button
									type="button"
									className="absolute right-0 -top-2 sm:-top-2 rounded-full border px-2 text-xs bg-red-100"
									onClick={(e) => removeIncome(i)}
								>
									X
								</button>
							) : (
								''
							)}
						</div>
					);
				})}
				<div className="flex justify-center">
					<button
						type="button"
						onClick={() => addIncome()}
						className="bg-emerald-500 transform hover:scale-105 transition-transform duration-400 rounded-md p-2 mt-2 text-white"
					>
						Add Another Income Source
					</button>
				</div>
			</div>
		</div>
	);
}
async function getSignature() {
	const response = await fetch('/api/cloudSign');
	const data = await response.json();

	const { signature, timestamp } = data;
	return { signature, timestamp };
}
